module.exports = __webpack_public_path__ + "img/icon3.12df9c3d.png";